import { string, shape, bool } from 'prop-types';

export default shape({
    PLATFORM: string.isRequired,
    IS_PLATFORM_FR: bool.isRequired,
    IS_PLATFORM_IT: bool.isRequired,
    IS_PLATFORM_UK: bool.isRequired,
    IS_PLATFORM_DE: bool.isRequired,
    IS_PLATFORM_ES: bool.isRequired,
});
